import { FC } from 'react';

import { SearchType } from '../../../types';
import ChipButton from '../../v1Overwrites/ChipButton/ChipButton';

import styles from './SearchTypeButtons.module.css';

type SearchTypeButtonsProps = {
  setChipInsideInput: (searchType: SearchType) => void;
  showJSONChip: boolean;
  isWithinAdvancedSearch: boolean;
};
const SearchTypeButtons: FC<SearchTypeButtonsProps> = ({
  setChipInsideInput,
  isWithinAdvancedSearch,
  showJSONChip,
}) => {
  return (
    <div className={styles.chipButtonContainerStyle}>
      <ChipButton testid='train-number-chip' onClick={() => setChipInsideInput('train')} label='Trein' />
      <ChipButton
        testid='rollingStock-number-chip'
        onClick={() => setChipInsideInput('rollingStock')}
        label='Eenheid'
      />
      <ChipButton testid='omloop-number-chip' label='Omloop' onClick={() => setChipInsideInput('omloop')} />
      {!isWithinAdvancedSearch && (
        <ChipButton
          testid='rollingStockType-number-chip'
          label='Type'
          onClick={() => setChipInsideInput('rollingStockType')}
        />
      )}
      {showJSONChip && <ChipButton testid='json-number-chip' label='JSON' onClick={() => setChipInsideInput('json')} />}
    </div>
  );
};
export default SearchTypeButtons;
